import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import useFormatter from "@coworker/app/src/hooks/useFormatter";

interface ItemDeliveryDateProps {
  deliveryDate: string | undefined;
}

export const ItemDeliveryDate = ({ deliveryDate }: ItemDeliveryDateProps) => {
  const { formatDateShort } = useFormatter();

  return (
    <FixaText
      textStyle={"Body.S"}
    >{`Indelivery ${formatDateShort(deliveryDate)}`}</FixaText>
  );
};
